



































import {
    defineComponent,
    PropType,
} from '@vue/composition-api';
import { SdsIcon } from '@superbet-group/web.lib.ui-components';
import EventCardLabel from './EventCardLabel.vue';
import { MetaData } from '@core/models/offer/MetaData';
import { useEventFormattedDate } from './composeable/date';

export default defineComponent({
    name: 'EventTime',
    props: {
        isLive: {
            type: Boolean,
            required: true,
        },
        liveData: {
            type: Object as PropType<MetaData>,
            default: null,
        },
        liveVideo: {
            type: Boolean,
            default: false,
        },
        startDate: {
            type: Date,
            default: null,
        },
    },
    setup(props) {
        const { formattedDate } = useEventFormattedDate(props.startDate);

        return {
            formattedDate,
        };
    },
    components: {
        EventCardLabel,
        SdsIcon,
    },

});
